import Token from '@/utils/Token';

export default {
    lista(params = '') {
        if (params) params = `?${params}`;
        return axios.get(`/api/backups${params}`, Token.getHeader());
    },

    downloadToken(id) {
        return axios.get(`/api/backups/${id}/download-token`, Token.getHeader());
    },

    run(onlyDb = false) {
        return axios.post('/api/backups/run', { only_db: onlyDb }, Token.getHeader());
    },

    monitor() {
        return axios.post('/api/backups/monitor', {}, Token.getHeader());
    },

    status() {
        return axios.get('/api/backups/status', Token.getHeader());
    },

    remove(id, confirmacao) {
        return axios.post(`/api/backups/${id}/remove`, { confirmacao }, Token.getHeader());
    },
}
